import { render, staticRenderFns } from "./BoxSerie.vue?vue&type=template&id=269869da&scoped=true"
import script from "./BoxSerie.vue?vue&type=script&lang=js"
export * from "./BoxSerie.vue?vue&type=script&lang=js"
import style0 from "./BoxSerie.vue?vue&type=style&index=0&id=269869da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "269869da",
  null
  
)

export default component.exports